import { XeroDisabledLogo } from '@approvalmax/ui';
import { Box, Button, Grid, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import type { FC } from 'react';

import { useIsInRoles } from '../../../../hooks/useIsInRoles';
import { useReadOnlyCompany } from '../../../../hooks/useReadOnlyCompany';
import { messages } from './XeroAccountConnectRequest.messages';
import type { XeroAccountConnectRequestProps } from './XeroAccountConnectRequest.types';

export const XeroAccountConnectRequest: FC<XeroAccountConnectRequestProps> = (props) => {
    const { onConnectXeroBankAccount } = props;

    const isReadOnly = useReadOnlyCompany();
    const isAuditor = useIsInRoles(domain.CompanyUserRole.Auditor);

    return (
        <Box bordered spacing='8' color='red20' radius='xsmall' borderColor='red60'>
            <Grid
                gap={8}
                alignItems='center'
                gridTemplateColumns={isAuditor ? 'max-content auto' : 'max-content auto max-content'}
            >
                <XeroDisabledLogo width={28} height={28} />

                <Text font='label' fontSize='medium' color='red100'>
                    {messages.accountMissing}
                </Text>

                {!isAuditor && (
                    <Button size='small' color='blue80' disabled={isReadOnly} onClick={onConnectXeroBankAccount}>
                        {messages.add}
                    </Button>
                )}
            </Grid>
        </Box>
    );
};

XeroAccountConnectRequest.displayName = 'XeroAccountConnectRequest';
